module.exports = __webpack_public_path__ + "static/rings-1df757d38e7f758ac50cf150db881416.svg";